import { getSettings } from "../repository/settings.repo";

export const GetSettings = async () => {
  try {
    const resp = await getSettings();
    return resp.data;
  } catch (error) {
    return error.response.data;
  }
};
